var map = {
	"./297_bistro.png": "c8c1",
	"./Caravan.png": "71f0",
	"./Fiorentinni.png": "eb91",
	"./Lawken.png": "2d46",
	"./Lorenza.png": "0d60",
	"./Patacon.png": "3088",
	"./Pizza_Cala.png": "2537",
	"./Senzo.png": "7188",
	"./Trawen.png": "d488",
	"./black_forest.png": "62e6",
	"./cafe_de_la_p.png": "e2fd",
	"./castillo.png": "c990",
	"./d_toros.png": "9192",
	"./la_materia.png": "7786",
	"./viva_peru.png": "d2cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0189";